<template>
  <div class="book">
    <v-container class="d-flex-column">
      <detail-card title="Πελάτης" api="customers/" nonBill=true :cid="this.$route.params.id">
        <template v-slot:tabsleft>
         <v-btn
        color="primary"
        dark
        @click="paymdialog=true"
         >
        <v-icon>mdi-cash-register</v-icon>
         </v-btn>
     <payment-dialog :cid="$route.params.id" :dialog.sync="paymdialog" apipath="customers/non-billing-debits" />
  </template>
      
      </detail-card>
    <v-sheet
      color="white"
      class="ma-3"
      elevation="2">
       <v-tabs>
          <v-tab replace :to="{ name: 'book-info' }">Πληρωμες</v-tab>
         <!-- <v-tab replace :to="{ name: 'book-repairs' }">Επισκευες</v-tab> -->
           <v-tab replace :to="{ name: 'book-customer-repairs' }">Επισκευες</v-tab>
          <v-tab replace :to="{ name: 'book-vehicles' }">Οχηματα</v-tab>
          <v-tab replace :to="{ name: 'book-repair-items' }">Ανταλλακτικα</v-tab>
          <v-tab replace :to="{ name: 'book-customer-documents' }">Εγγραφα</v-tab>
          <v-tab replace :to="{ name: 'book-contacts' }">Επαφες</v-tab>
        </v-tabs>
      </v-sheet>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import DetailCard from "../../components/DetailCard.vue";
import PaymentDialog from "../../components/PaymentDialog.vue";

export default {
  components: {
    DetailCard,
    PaymentDialog,
  },
  data() {
    return {
      expanded: [],
      paymdialog: false,
      diaitems: {},
      loading: true,
      balance: 0.0,
      info: {
        name: "",
        address: "",
        telephone: "",
        nino: "",
        doi: "",
        city: "",
      },
      search: "",
      customer_id: this.$route.params.id,
      headers: [
        {
          text: "Ημερομηνία",
          align: "start",
          //sortable: false,
          value: "date",
          width: "10%",
        },
        { text: "Όχημα", value: "vehicle" },
        { text: "Αιτιολογία", value: "reason", width: "20%" },
        { text: "Σημανση", value: "mark" },
        { text: "Κατάσταση", value: "state" },
        { text: "Πίστωση", value: "credit", align: "end" },
        { text: "Χρέωση", value: "debit", align: "end" },
        { text: "Παραστατικό", value: "rel_invoice", align: "center" },
        { text: "Προσφορά", value: "quote" },
        { text: "Ενέργειες", value: "actions" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  async created() {
    try {
     // const response = await this.$api.get(
    //    "/customers/byid/" + this.$route.params.id,
     //   {params: {'non-billing': 1}}
     // );
      //console.log(response);
     // this.$store.gcustomer = response.data;
      this.loading = false;
    } catch (error) {
      console.error(error);
    }
  },
  methods: {},
};
</script>
